import { PromoBannerComponentName, PromotionCampaignPrefix } from '../../../../models';
import { ReactComponent as LeftBackground } from '../../../../components/icons/promotion-banner/left-background.svg';
import { ReactComponent as Hourglass } from '../../../../components/icons/promotion-banner/hourglass.svg';
import { ReactComponent as HolidayLeftBackground } from '../../../../components/icons/promotion-banner/holiday-offer/left-background.svg';
import { ReactComponent as HolidayHourglass } from '../../../../components/icons/promotion-banner/holiday-offer/hourglass.svg';
import { ReactComponent as NewYear2025LeftBg } from '../../../../components/icons/promotion-banner/newyear2025-offer/left-background.svg';
import { ReactComponent as NewYear2025Hourglass } from '../../../../components/icons/promotion-banner/newyear2025-offer/hourglass.svg';
import { ReactComponent as BlackFridayLeft } from '../../../../components/icons/promotion-banner/black-friday/left-background.svg';
import { ReactComponent as RightBackground } from '../../../../components/icons/promotion-banner/black-friday/right-background.svg';
import {
  LeftBackground as NY2026LeftBg,
  MidBackground as NY2026MidBg,
  RightBackground as NY2026RightBg,
} from '../../../../components/icons/promotion-banner/new-year-2026';

const bannerAssets: Record<PromotionCampaignPrefix, Map<PromoBannerComponentName, JSX.Element>> = {
  [PromotionCampaignPrefix.DEFAULT]: new Map([
    [PromoBannerComponentName.LEFT_BACKGROUND, <LeftBackground />],
    [PromoBannerComponentName.HOUR_GLASS, <Hourglass />],
  ]),
  [PromotionCampaignPrefix.HOLIDAYPROMO]: new Map([
    [PromoBannerComponentName.LEFT_BACKGROUND, <HolidayLeftBackground />],
    [PromoBannerComponentName.HOUR_GLASS, <HolidayHourglass />],
  ]),
  [PromotionCampaignPrefix.NEWYEAR2025]: new Map([
    [PromoBannerComponentName.LEFT_BACKGROUND, <NewYear2025LeftBg />],
    [PromoBannerComponentName.HOUR_GLASS, <NewYear2025Hourglass />],
  ]),
  [PromotionCampaignPrefix.BLACKFRIDAY]: new Map([
    [PromoBannerComponentName.LEFT_BACKGROUND, <BlackFridayLeft />],
    [PromoBannerComponentName.HOUR_GLASS, <Hourglass />],
    [PromoBannerComponentName.RIGHT_BACKGROUND, <RightBackground />],
  ]),
  [PromotionCampaignPrefix.NEWYEAR2026]: new Map([
    [PromoBannerComponentName.LEFT_BACKGROUND, <NY2026LeftBg />],
    [PromoBannerComponentName.MID_BACKGROUND, <NY2026MidBg />],
    [PromoBannerComponentName.RIGHT_BACKGROUND, <NY2026RightBg />],
  ]),
};

export default bannerAssets;
